import { render, staticRenderFns } from "./server-resize.vue?vue&type=template&id=7a637d96&scoped=true&"
import script from "./server-resize.vue?vue&type=script&lang=js&"
export * from "./server-resize.vue?vue&type=script&lang=js&"
import style0 from "./server-resize.vue?vue&type=style&index=0&id=7a637d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a637d96",
  null
  
)

export default component.exports